import React from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';

import { ContentZonesService } from '@sm360/widget-commons-core-services';
import { ModalService } from '@sm360/widget-commons-general';
import { Quote } from '@sm360/widget-commons-vehicle';

import ConfigsService from 'login/services/ConfigsService/ConfigsService.js';

import SignInForm from 'login/components/SignIn/SignInForm/SignInForm.jsx';
import InformationZone from 'login/components/Library/InformationZone/InformationZone.jsx';
import ModalHeader from 'login/components/Library/ModalHeader/ModalHeader.jsx';
import FacebookBtn from 'login/components/Library/FacebookBtn/FacebookBtn.jsx';
import Separator from 'login/components/Library/Separator/Separator.jsx';
import PrivacyPolicy from 'login/components/Library/PrivacyPolicy/PrivacyPolicy.jsx';
import ForgetPasswordLink from 'login/components/SignIn/Links/ForgetPasswordLink.jsx';
import SignUpLink from 'login/components/SignIn/Links/SignupLink.jsx';

import { SAVE_CONFIRMATION, LOGIN as MODAL } from 'login/constants/modalNames.js';

import 'login/components/SignIn/SignInModal.scss';

const czGroupName = 'widget.login.forms.login';

// TODO - Remove when "Old" CZ image will be no longer usefull
const czGroupNameOldImage = 'widget.login.forms.signup';

class SignInContent extends React.Component {
    constructor() {
        super();
        this.modal = ModalService.get(MODAL);
        this.saveConfirmation = ModalService.get(SAVE_CONFIRMATION);

        this.headerTitleCz =
            ContentZonesService.getContentZone(czGroupName, 'maintext') &&
            ContentZonesService.getContentZone(czGroupName, 'maintext').getText();
        this.headerTextCz =
            ContentZonesService.getContentZone(czGroupName, 'subtext') &&
            ContentZonesService.getContentZone(czGroupName, 'subtext').getText();
        this.modalImageUrl =
            ContentZonesService.getContentZone(czGroupNameOldImage, 'image') &&
            ContentZonesService.getContentZone(czGroupNameOldImage, 'image').getValue();

        this.hideFacebook =
            ContentZonesService.getContentZone('widget.login.popup', 'widget.login.popup.facebook.disable') &&
            ContentZonesService.getContentZone(
                'widget.login.popup',
                'widget.login.popup.facebook.disable'
            ).getText() === 'true';

        this.switchToConfirmation = this.switchToConfirmation.bind(this);
    }

    switchToConfirmation() {
        this.saveConfirmation.addOnCloseCallbackFromAnotherModal(this.modal);
        this.saveConfirmation.open({ context: 'widget.login.signup.information' });
        this.modal.close(true);
    }

    render() {
        const classUtil = isString(this.props.classParam) ? this.props.classParam : '';
        const faceBookBlock = !this.hideFacebook &&
            ConfigsService.getFacebookAppId() && (
                <div>
                    <div className="fb-login">
                        <FacebookBtn
                            closeDialog={this.props.hasConfirmation ? this.switchToConfirmation : this.modal.close}
                        />
                    </div>
                    <Separator />
                </div>
            );
        return (
            <div className={`modal-login-content ${classUtil}`}>
                <div className="SignInForm">
                    <ModalHeader
                        titleContentZone={this.headerTitleCz}
                        textContentZone={this.headerTextCz}
                        showImage
                        showText
                    />

                    {faceBookBlock}

                    <SignInForm
                        onLogin={this.props.hasConfirmation ? this.switchToConfirmation : this.modal.close}
                        quote={this.props.quote}
                        hasAdobeTagging={this.props.hasAdobeTagging}
                    />
                    <SignUpLink hasAdobeTagging={this.props.hasAdobeTagging} />
                    <ForgetPasswordLink hasAdobeTagging={this.props.hasAdobeTagging} />
                    <PrivacyPolicy />
                </div>
                <InformationZone groupName={this.props.context} czOldImage={this.modalImageUrl} />
            </div>
        );
    }
}
SignInContent.defaultProps = {
    classParam: null,
    context: 'widget.login.signup.information',
    hasConfirmation: false,
    quote: new Quote.QuoteModel(),
    hasAdobeTagging: false,
};

SignInContent.propTypes = {
    context: PropTypes.string,
    classParam: PropTypes.string,
    hasConfirmation: PropTypes.bool,
    quote: PropTypes.instanceOf(Quote.QuoteModel),
    hasAdobeTagging: PropTypes.bool,
};

SignInContent.displayName = 'SignInContent';

export default SignInContent;
